import React from 'react'
import { HomePanelWrapperProps } from './HomePanelWrapper.interface'
import styles from './HomePanelWrapper.module.scss'

const HomePanelWrapper: React.FC<HomePanelWrapperProps> = ({
  children,
  backgroundImageUrl,
  mobileBackgroundImageUrl,
  tabletBackgroundImageUrl,
  outerClassName,
  innerClassName,
  altText,
}) => {
  // Set CSS variables for all three URLs so they can be accessed inside the SCSS media queries
  const backgroundStyle = {
    // Pass the primary desktop URL via a CSS variable
    '--desktop-bg-url': backgroundImageUrl ? `url(${backgroundImageUrl})` : 'none',
    // Pass the mobile URL via a CSS variable
    '--mobile-bg-url': mobileBackgroundImageUrl ? `url(${mobileBackgroundImageUrl})` : 'none',
    // Pass the tablet URL via a CSS variable
    '--tablet-bg-url': tabletBackgroundImageUrl ? `url(${tabletBackgroundImageUrl})` : 'none',
  } as React.CSSProperties // Assert as React.CSSProperties for inline variables

  return (
    <section
      // 💡 Apply the CSS variables inline
      style={backgroundStyle}
      className={`
        ${styles.section} 
        ${outerClassName || ''} 
        ${styles.cssBackground} // This class applies the background-image, size: cover, and media queries
      `}
      aria-label={altText} // Use altText for accessibility of the section
    >
      {/* Inner Content Wrapper */}
      <div
        className={`
          ${styles.container} 
          ${innerClassName || ''}
        `}
      >
        {children}
      </div>
    </section>
  )
}

export default HomePanelWrapper
